module.exports = __webpack_public_path__ + "img/phone-mockup.ba60effe.png";